const download = {
  displayField: 'url',
  name: 'Download',
  description: '',
  fields: [
    {
      id: 'url',
      name: 'Url',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'download',
    version: 18,
    updatedAt: '2023-04-21T17:29:43.914Z'
  }
};
export default download;